import React, { ComponentType } from "react";

export function bindProps<P, K extends keyof P>(
  Component: ComponentType<P>,
  boundProps: Pick<P, K>
): React.StatelessComponent<Omit<P, K>> {
  return (props) => {
    const componentProps = { ...props, ...boundProps } as P;

    return <Component {...componentProps} />;
  };
}
